import React from "react";
import "../styles/Testimonials.css";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import img from "../images/testimonials/p.jpg"
import img1 from "../images/testimonials/p1.jpg"
import img2 from "../images/testimonials/p2.jpg"
import img3 from "../images/testimonials/p3.jpg"

const testimonials = [
  {
    text: "They were even mindful of using natural cleaning products for my kids’ room. I really appreciated the attention to detail.",
    name: "Brian Otieno",
    role: "Client",
    image: img1,
  },
  {
    text: "Amazing service! My car looked brand new again. Very professional team and on time.",
    name: "Faith Wanjiku",
    role: "Client",
    image: img,
  },
  {
    text: "Very reliable service. My carpets were cleaned perfectly and dried fast.",
    name: "Kevin Mwangi",
    role: "Client",
    image:img2,
  },
  {
    text: "Best barber experience. Clean, sharp cut and great customer service.",
    name: "James Kiptoo",
    role: "Client",
    image: img3,
  },
];
const groupedTestimonials = [];
for (let i = 0; i < testimonials.length; i += 2) {
  groupedTestimonials.push(testimonials.slice(i, i + 2));
}

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <span>Testimonials</span>
        <h2>What Our Clients Think</h2>

     
      </div>

      <div className="carousel-wrapper">
        <Carousel
          showThumbs={false}
          showStatus={false}
          infiniteLoop
          autoPlay
          interval={4000}
          showArrows={false}
          swipeable
          emulateTouch
          renderIndicator={(onClickHandler, isSelected, index) => (
            <span
              key={index}
              className={isSelected ? "dot active" : "dot"}
              onClick={onClickHandler}
            />
          )}
        >
          {groupedTestimonials.map((group, index) => (
            <div className="testimonial-slide" key={index}>
              {group.map((item, i) => (
                <div className="testimonial-card" key={i}>
                  <div className="quote">“</div>

                  <p>{item.text}</p>

                  <div className="user">
                    <img src={item.image} alt={item.name} />
                    <div>
                      <h4>{item.name}</h4>
                      <span>{item.role}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Testimonials;